import {
  openPartsNavigation,
  OpenPartsNavigationAction,
} from '../actions/navigationActions'

export const KNOWN_DISPATCH_ACTIONS = {
  openPartsNavigation: openPartsNavigation as () => OpenPartsNavigationAction,
}
